// extracted by mini-css-extract-plugin
export var root = "y_tR";
export var wrapper = "y_tS";
export var image = "y_tT d_w d_y d_W";
export var imageWithHeight = "y_tV";
export var crop = "y_tW";
export var round = "y_tX";
export var fixedHeight = "y_tY";